import { Plans } from '../translations-types';

const translations: Plans = {
  title: 'Trajecten/kuren',
  description:
    'Definieer een traject (vrije naam) met een gekoppelde vragenlijst. Voeg cliënten toe, vraag of ze het traject willen, en bij "ja" krijgen ze automatisch de vragenlijst.',
  newPlan: 'Nieuw traject',
  editPlan: 'Traject bewerken',
  renew: 'Verlengen',
  renewPlan: 'Traject verlengen',
  deletePlan: 'Traject verwijderen',
  deleteConfirm: 'Weet je het zeker? Het traject wordt verwijderd.',
  deleteBlocked: 'Verwijderen kan alleen als er geen actieve leden zijn.',
  yearTooFar: 'Jaartal mag maximaal 1 jaar in de toekomst liggen.',
  renewMaxYear: 'Je kunt maximaal 1 jaar vooruit verlengen.',
  statusColumn: 'Status',
  statusAskedSent: 'Vraag verstuurd',
  statusAgreed: 'Akkoord',
  statusNotAgreed: 'Niet akkoord',
  qSentLong: 'Vragenlijst verstuurd',
  qCompletedLong: 'Vragenlijst ingevuld',
  name: 'Naam',
  year: 'Jaar',
  planDescription: 'Omschrijving',
  previewOfferEmail: 'Voorbeeld mail',
  previewOfferEmailTitle: 'Voorbeeld akkoord-mail',
  previewGreeting: 'Beste [naam cliënt],',
  previewIntro: 'Graag horen we of je volgend jaar wilt doorgaan met {plan}. Je kunt hieronder in één klik ja of nee doorgeven.',
  previewAnswerLabel: 'Geef je antwoord door:',
  previewAnswerLink: 'Ja of nee doorgeven',
  previewYesInfo: 'Kies je voor ja, dan ontvang je van ons de bijbehorende vragenlijst per e-mail.',
  previewClosing: 'Met vriendelijke groeten,',
  previewPlanFallback: 'dit traject',
  questionnaire: 'Vragenlijst',
  status: 'Status',
  active: 'Actief',
  archived: 'Gearchiveerd',
  selectPlan: 'Kies een traject',
  noPlans: 'Nog geen trajecten',
  saved: 'Opgeslagen',
  deleted: 'Verwijderd',
  addCustomers: 'Cliënten toevoegen',
  addManual: 'Handmatig',
  fromPlan: 'Vorig traject',
  fromPlanHint: 'Neem de leden (met ja) van een ander traject over.',
  fromField: 'Klantlabel',
  fromFieldHint: 'Filter cliënten op een klantlabel.',
  selectField: 'Kies een klantlabel',
  fieldValue: 'Waarde (leeg = elke ingevulde waarde)',
  selectCustomers: 'Zoek en selecteer cliënten',
  add: 'Toevoegen',
  found: 'Gevonden',
  notFound: 'Niet gevonden',
  overview: 'Overzicht',
  customer: 'Cliënt',
  askStatus: 'Cliënt akkoord',
  questionnaireStatus: 'Vragenlijst',
  statusAdded: 'Toegevoegd',
  statusPending: 'Gevraagd',
  statusAccepted: 'Ja',
  statusDeclined: 'Nee',
  statusNoResponse: 'Geen reactie',
  qNotSent: '—',
  qSent: 'Verstuurd',
  qCompleted: 'Ingevuld',
  sendAsk: 'Verstuur vraag',
  resendAsk: 'Opnieuw versturen',
  sendAskAll: 'Verstuur aan iedereen',
  askSent: 'Vraag verstuurd',
  askSentAll: '{count} vragen verstuurd',
  setAccepted: 'Op ja',
  setDeclined: 'Op nee',
  noOffers: 'Nog geen cliënten toegevoegd',
  members: 'leden',
  searchCustomer: 'Zoek cliënt',
  searchPlans: 'Zoek traject',
  allStatuses: 'Alle',
  planKind: 'Soort',
  renewableOption: 'Verlengbaar',
  oneTimeOption: 'Eenmalig',
  durationType: 'Looptijd',
  durationCalendarYear: 'Kalenderjaar',
  durationCustomerStart: 'Vanaf cliënt-startdatum',
  durationMonthsOption: 'Aantal maanden',
  durationTreatments: 'Aantal behandelingen',
  durationMonths: 'Maanden',
  treatmentCountLabel: 'Aantal behandelingen',
  plannedTreatmentsHint: 'Aantal geplande behandelingen in deze periode (optioneel, per lid aanpasbaar)',
  startDate: 'Startdatum',
  endDate: 'Einddatum',
  treatmentsDoneLabel: 'Afspraken',
  treatmentPlan: 'Behandelplan',
  treatmentPlanNote: 'Notitie',
  lastCompletedColumn: 'Laatst ingevuld',
  overviewButton: 'Overzicht',
  overviewAnswersTitle: 'Antwoorden',
  overviewAppointmentsTitle: 'Afspraken in deze periode',
  planningProposalTitle: 'Planningsvoorstel',
  generateProposal: 'Genereer planningsvoorstel',
  regenerateProposal: 'Opnieuw genereren',
  proposalGeneratedAt: 'Gegenereerd op',
  proposalGenerating: 'Bezig met genereren…',
  proposalNotesLabel: 'Opmerkingen voor de planning',
  proposalNotesPlaceholder: 'Deze opmerkingen krijgen voorrang op de standaardinstructie.',
  carryOver: 'Deelnemers overnemen uit',
  carryOverHint:
    'De "Ja"-leden van het gekozen traject komen als "Toegevoegd" in dit nieuwe traject; verleng ze daarna per persoon via "Op ja" of de verleng-vraag.',
  expiringSoon: 'Loopt bijna af',
  expired: 'Verlopen',
  goalReached: 'Doel bereikt',
  expiryFilter: 'Aflopen',
  expiringCountLabel: 'lopen bijna af',
  linkAppointments: 'Afspraken koppelen',
  linkAppointmentsTitle: 'Afspraken koppelen aan traject',
  appointmentDate: 'Datum',
  appointmentService: 'Behandeling',
  appointmentEmployee: 'Medewerker',
  plannedHint: 'Gepland — telt mee zodra de afspraak is geweest',
  syncedOnlyHint: 'Alleen gesynchroniseerde afspraken worden getoond.',
  noAppointments: 'Geen afspraken gevonden',
  manualApproval: 'Handmatig akkoord',
  manageMembership: 'Lidmaatschap',
  membershipNotRenewing: 'Niet verlengen',
  membershipStopped: 'Gestopt',
  membershipSwitched: 'Overgestapt',
  membershipWillRenew: 'Wil verlengen',
  membershipRenewed: 'Is verlengd',
  actionStop: 'Voortijdig stoppen',
  actionSwitchNow: 'Overstappen (tussentijds)',
  actionSwitchEnd: 'Overstappen (einde looptijd)',
  reactivate: 'Weer activeren',
  switchTargetPlan: 'Doeltraject',
  exitDate: 'Datum',
  exitReason: 'Reden',
  switchTimingImmediate: 'tussentijds',
  switchTimingEnd: 'einde looptijd',
  endedCountLabel: 'gestopt/overgestapt',
};

export default translations;
